module.exports = __webpack_public_path__ + "img/9.7b0f9730.jpg";